
import { useState } from "react"
import { useForm } from "react-hook-form"
import { useNavigate } from "react-router-dom"
import { supabase } from "@/integrations/supabase/client"
import { Form } from "@/components/ui/form"
import { useToast } from "@/hooks/use-toast"
import { RegistrationFormFields } from "@/components/auth/RegistrationFormFields"
import { RegistrationFormData } from "@/types/auth"

type RegistrationFormProps = {
  onSuccessCallback?: () => void
  adminCreating?: boolean
}

export function RegistrationForm({ onSuccessCallback, adminCreating = false }: RegistrationFormProps) {
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()
  const { toast } = useToast()
  
  const form = useForm<RegistrationFormData>({
    defaultValues: {
      firstName: "",
      lastName: "",
      email: "",
      password: "",
      role: "vereador",
      state: "",
      city: "",
    },
  })

  const onSubmit = async (data: RegistrationFormData) => {
    setLoading(true)
    try {
      // Signup user with Supabase Auth
      const { data: authData, error: signupError } = await supabase.auth.signUp({
        email: data.email,
        password: data.password,
        options: {
          data: {
            first_name: data.firstName,
            last_name: data.lastName,
            role: data.role,
            prefeito: data.prefeito || "",
            state: data.state,
            city: data.city
          },
        },
      })

      if (signupError) throw signupError

      // Update the profile with state and city
      if (authData.user) {
        const { error: profileError } = await supabase
          .from('profiles')
          .update({
            state: data.state,
            city: data.city,
          })
          .eq('id', authData.user.id)

        if (profileError) throw profileError
      }

      toast({
        title: "Cadastro realizado com sucesso!",
        description: "Você já pode fazer login no sistema.",
      })

      if (onSuccessCallback) {
        onSuccessCallback()
      } else {
        navigate("/login")
      }
    } catch (error: any) {
      console.error("Erro no cadastro:", error)
      toast({
        variant: "destructive",
        title: "Erro no cadastro",
        description: error.message || "Ocorreu um erro ao criar sua conta.",
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="bg-white shadow-md rounded-lg p-6 w-full max-w-4xl mx-auto">
      <Form {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-8">
          <RegistrationFormFields form={form} loading={loading} adminCreating={adminCreating} />
        </form>
      </Form>
    </div>
  )
}
